import useSite from '~/client/hooks/useSite';

const useTermsUrl = () => {
  const TERMS_AND_CONDITIONS_URL: SiteRecord<string> = {
    bitcasino:
      '/help-center/help-terms-and-conditions/bitcasino-terms-and-conditions-of-use-of-services-of-the-company',
    sportsbet: '/about/terms-and-conditions',
    livecasino: '/help-center/help-terms-and-conditions/terms-and-conditions',
    sportsbetmx: '/about/terms-and-conditions',
    empire:
      '/help-center/help-terms-and-conditions/empire-terms-and-conditions-of-use-of-services-of-the-company',
  };
  const { site } = useSite();
  return TERMS_AND_CONDITIONS_URL[site];
};

export default useTermsUrl;
